// extracted by mini-css-extract-plugin
export default {"back":"_1CR8i9pAFhP8V6Un1Im0Fi","black":"_3911nL69dzpxQhkqIj6WFg _1CR8i9pAFhP8V6Un1Im0Fi","label":"BCDBewSu03oU18XNfnG2V"};